<div class="channel-info-img">
    <app-channel-info
        [editPermission]="edit"
        [channelData]="channelData"></app-channel-info>
</div>

<div class="router-block">
    <ul class="router-list">
        <li class="router-list-item"
            [routerLinkActiveOptions]="{exact:true}"
            #rla="routerLinkActive"
            [routerLinkActive]="'active'">
            <a [routerLink]="['watchlist']">Watchlist</a>
        </li>

        <li class="router-list-item"
            [routerLinkActiveOptions]="{exact:true}"
            #rla="routerLinkActive"
            [routerLinkActive]="'active'">
            <a [routerLink]="['channel-videos',channelData?.id]">Videos</a>
        </li>

        <li class="router-list-item"
            [routerLinkActiveOptions]="{exact:true}"
            #rla="routerLinkActive"
            [routerLinkActive]="'active'"
        >
            <a [routerLink]="['channel-playlist',channelData?.id]">Playlist</a>
        </li>

        <li class="router-list-item"
            [routerLinkActiveOptions]="{exact:true}"
            #rla="routerLinkActive"
            [routerLinkActive]="'active'">
            <a [routerLink]="['channel-subscriptions',channelData?.id]">Contacts</a>
        </li>

        <li class="router-list-item"
            [routerLinkActiveOptions]="{exact:true}"
            #rla="routerLinkActive"
            [routerLinkActive]="'active'">
            <a [routerLink]="['channel-about',channelData?.id]">About Us</a>
        </li>
    </ul>
</div>

<div>
    <router-outlet></router-outlet>
</div>


